import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5b28684&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c5b28684&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b28684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b28684')) {
      api.createRecord('c5b28684', component.options)
    } else {
      api.reload('c5b28684', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5b28684&scoped=true", function () {
      api.rerender('c5b28684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/Listwidth/index.vue"
export default component.exports